var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3PlLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 380,
    viewBox: "0 0 426 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4841 0L211.9 190L72.4848 380H220.537L359.952 190H359.952L220.536 0H72.4841Z",
    fill: "url(#paint0_linear_76_6087)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_6087",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 0,
    width: 288,
    height: 380
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4827 0L211.898 190L72.4833 380H220.535L359.951 190H359.95L220.535 0H72.4827Z",
    fill: "url(#paint1_linear_76_6087)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_6087)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_76_6087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.097 190H409.098L316.154 63.3333H217.453L310.396 190H310.396L217.452 316.667H316.153L409.097 190Z",
    fill: "#0F5683"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_76_6087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5001 190L36.4994 190L129.443 316.667L228.144 316.667L135.201 190L135.202 190L228.145 63.3336L129.444 63.3336L36.5001 190Z",
    fill: "#0F5683"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.847 190H425.549L332.605 63.3332H233.904L326.847 190ZM332.604 316.667H233.903L326.847 190H425.548L332.604 316.667Z",
    fill: "#85D0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7012 190H-8.00461e-05L92.9434 63.3331H191.645L98.7012 190ZM92.9442 316.666H191.646L98.702 190H0.000484529L92.9442 316.666Z",
    fill: "#F8766D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_76_6087",
    x: 193.452,
    y: 39.3333,
    width: 239.646,
    height: 301.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_76_6087"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_76_6087",
    x: 12.4995,
    y: 39.3336,
    width: 239.646,
    height: 301.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_76_6087"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_6087",
    x1: 72.4841,
    y1: 379.771,
    x2: 332.19,
    y2: 379.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FB1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F649A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_6087",
    x1: 72.4827,
    y1: 379.771,
    x2: 332.188,
    y2: 379.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FB1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F649A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3PlLogo);
export default __webpack_public_path__ + "static/media/3plLogo.85bd2194d5ef7b205c1275dc04c3db5b.svg";
export { ForwardRef as ReactComponent };